import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Alanditomumbaicabservice() {



  const cardData = {


  keyword: "Alandi to Mumbai Cabs Service",

  headingDescription: "Trustline Cab offers reliable Alandi to Mumbai cab services with safe, comfortable, and affordable transportation for corporate travel, airport transfers, business meetings, family trips, pilgrimage travel, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Alandi to Mumbai taxi services.",

  topPlaces: [
    {
      title: "Andheri East",
      description: "Andheri East is one of Mumbai's busiest commercial hubs, known for corporate offices, business parks, hotels, and excellent connectivity to the international airport."
    },
    {
      title: "Bandra West",
      description: "Bandra West is a vibrant business and lifestyle destination featuring premium offices, retail outlets, cafés, and excellent road connectivity."
    },
    {
      title: "Chembur",
      description: "Chembur is a prominent residential and commercial locality with corporate offices, educational institutions, business centers, and easy access to Navi Mumbai."
    },
    {
      title: "Vikhroli",
      description: "Vikhroli is a rapidly developing commercial area known for technology companies, business parks, and modern office complexes."
    },
    {
      title: "SEEPZ MIDC",
      description: "SEEPZ MIDC is one of India's largest export processing zones, housing leading IT companies, software firms, and electronics manufacturers."
    },
    {
      title: "Peninsula Corporate Park",
      description: "Peninsula Corporate Park in Lower Parel is a prestigious business destination with multinational corporations, financial firms, and premium office spaces."
    },
    {
      title: "Worli Sea Face",
      description: "Worli Sea Face is a scenic waterfront promenade offering spectacular Arabian Sea views and a relaxing atmosphere."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site renowned for its ancient rock-cut temples and remarkable sculptures dedicated to Lord Shiva."
    },
    {
      title: "Hanging Gardens",
      description: "Hanging Gardens is a beautifully landscaped hilltop garden offering panoramic views of Mumbai's skyline and the Arabian Sea."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is a famous shopping and cultural destination known for local markets, fashion stores, cafés, and heritage architecture."
    }
  ],






  "services": [
    {
      "name": "Alandi to Mumbai Cab",
      "description": "Book Alandi to Mumbai cab for safe, comfortable, and affordable outstation travel with experienced drivers and clean AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for one-way, round-trip, airport transfers, business travel, and family trips. Enjoy doorstep pickup, transparent pricing, and 24x7 customer support for a hassle-free journey."
    },
    {
      "name": "Alandi to Mumbai Taxi",
      "description": "Hire Alandi to Mumbai taxi service with professional chauffeurs, well-maintained vehicles, and affordable fares. Our taxi service is ideal for airport transfers, corporate travel, family vacations, and comfortable long-distance journeys."
    },
    {
      "name": "Alandi to Mumbai Cab Service",
      "description": "Our Alandi to Mumbai cab service provides reliable one-way and round-trip taxi bookings with punctual pickups, sanitized vehicles, transparent fares, and experienced drivers for a smooth travel experience."
    },
    {
      "name": "Alandi to Mumbai Taxi Service",
      "description": "Travel comfortably with Alandi to Mumbai taxi service offering premium AC cars, affordable prices, flexible travel plans, and professional drivers for business and leisure trips."
    },
    {
      "name": "Alandi to Mumbai Cab Booking",
      "description": "Book Alandi to Mumbai cab online with instant confirmation, quick reservation, multiple vehicle options, secure booking process, and dedicated customer support available 24x7."
    },
    {
      "name": "Cab from Alandi to Mumbai",
      "description": "Hire a private cab from Alandi to Mumbai with experienced chauffeurs, clean vehicles, comfortable seating, and convenient doorstep pickup for every journey."
    },
    {
      "name": "Alandi to Mumbai Car Rental",
      "description": "Choose Alandi to Mumbai car rental service for chauffeur-driven travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles suitable for business, family, and airport transfers."
    },
    {
      "name": "Alandi to Mumbai One Way Cab",
      "description": "Book Alandi to Mumbai one way cab for economical single-side travel without paying return charges. Perfect for airport drops, business meetings, and personal travel."
    },
    {
      "name": "Cheap Alandi to Mumbai Cabs",
      "description": "Get cheap Alandi to Mumbai cabs with budget-friendly fares, professional drivers, comfortable AC vehicles, and reliable outstation taxi services."
    },
    {
      "name": "Alandi to Mumbai Taxi Fare",
      "description": "Check Alandi to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV cabs without hidden charges."
    },
    {
      "name": "Book Alandi to Mumbai Cab Online",
      "description": "Reserve Alandi to Mumbai cab online through a simple booking process with instant confirmation, competitive prices, and trusted outstation taxi service."
    },
    {
      "name": "Alandi to Mumbai Outstation Cab",
      "description": "Travel safely with Alandi to Mumbai outstation cab service featuring experienced chauffeurs, well-maintained vehicles, flexible travel options, and comfortable highway journeys."
    },
    {
      "name": "Alandi to Mumbai Airport Cab",
      "description": "Book Alandi to Mumbai Airport cab for timely airport transfers with luggage assistance, AC vehicles, professional drivers, and dependable pickup and drop services."
    },
    {
      "name": "24x7 Alandi to Mumbai Taxi Service",
      "description": "Our 24x7 Alandi to Mumbai taxi service is available anytime for airport transfers, emergency travel, corporate transportation, and family trips with reliable vehicles."
    },
    {
      "name": "Best Alandi to Mumbai Cab Service",
      "description": "Choose the best Alandi to Mumbai cab service for premium travel experience with affordable fares, clean cars, experienced drivers, transparent pricing, and excellent customer support."
    },
    {
      "name": "Alandi to Mumbai Airport Cabs",
      "description": "Book Alandi to Mumbai Airport cabs for convenient airport transportation with comfortable vehicles, punctual pickups, and experienced chauffeurs."
    },
    {
      "name": "Cab Service in Alandi Pune",
      "description": "Our cab service in Alandi Pune offers local taxi, airport transfers, railway station pickup, corporate travel, and outstation cab services with professional drivers and clean AC vehicles."
    },
    {
      "name": "Cab Service in Alandi Pune Contact Number",
      "description": "Contact our Alandi Pune cab service for instant taxi booking, fare information, vehicle availability, airport transfers, and outstation travel assistance."
    },
    {
      "name": "Cab Service in Alandi",
      "description": "Book trusted cab service in Alandi for local rides, airport transfers, railway station pickup, business travel, and long-distance outstation journeys."
    },
    {
      "name": "Cab Service in Wadmukhwadi",
      "description": "Cab service in Wadmukhwadi provides reliable local and outstation taxi services with professional chauffeurs, affordable pricing, and comfortable vehicles."
    },
    {
      "name": "Cab Service in Charholi Budruk",
      "description": "Hire cab service in Charholi Budruk for airport transfers, local travel, business meetings, and outstation taxi bookings with experienced drivers."
    },
    {
      "name": "24 Hours Cab Service in Charholi",
      "description": "Book 24 hours cab service in Charholi for round-the-clock airport transfers, emergency travel, local rides, and outstation transportation."
    },
    {
      "name": "Charholi to Mumbai Cab Service",
      "description": "Choose Charholi to Mumbai cab service for comfortable outstation travel with AC vehicles, experienced chauffeurs, and affordable one-way or round-trip options."
    },
    {
      "name": "Moshi to Mumbai Cab Service",
      "description": "Book Moshi to Mumbai cab service for business travel, airport transfers, family trips, and outstation journeys with Sedan, Ertiga, and Innova Crysta cabs."
    },
    {
      "name": "Moshi to Mumbai Cab Fare",
      "description": "Check Moshi to Mumbai cab fare with transparent pricing for one-way, round-trip, and premium vehicle options."
    },
    {
      "name": "Moshi to Mumbai Airport Cab Fare",
      "description": "Get Moshi to Mumbai Airport cab fare for affordable airport transfers with reliable service and professional drivers."
    },
    {
      "name": "Moshi to Mumbai Round Trip Cab Fare",
      "description": "Book Moshi to Mumbai round-trip cab at competitive rates with flexible return schedules, comfortable vehicles, and experienced chauffeurs."
    },
    {
      "name": "Cab Service in Moshi",
      "description": "Cab service in Moshi offers local taxi, airport transfers, corporate transportation, railway station pickup, and outstation travel with premium AC vehicles."
    },
    {
      "name": "Cheapest Cab Service in Moshi",
      "description": "Hire the cheapest cab service in Moshi with affordable fares, reliable drivers, clean vehicles, and quality local and outstation taxi solutions."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Our cab service in Pune provides local taxi, airport transfers, railway station pickup, corporate transportation, and outstation cab services with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book Pune to Mumbai Airport cab for safe and timely airport transfers with professional chauffeurs, comfortable AC cars, and transparent pricing."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Pune Mumbai cab service offers one-way, round-trip, airport transfer, corporate travel, and family transportation with reliable drivers and premium vehicles."
    }
  ],

  "tableData": [
    ["Alandi to Mumbai Cab", "Alandi to Mumbai Taxi"],
    ["Alandi to Mumbai Cab Service", "Alandi to Mumbai Taxi Service"],
    ["Alandi to Mumbai Cab Booking", "Cab from Alandi to Mumbai"],
    ["Alandi to Mumbai Car Rental", "Alandi to Mumbai One Way Cab"],
    ["Cheap Alandi to Mumbai Cabs", "Alandi to Mumbai Taxi Fare"],
    ["Book Alandi to Mumbai Cab Online", "Alandi to Mumbai Outstation Cab"],
    ["Alandi to Mumbai Airport Cab", "24x7 Alandi to Mumbai Taxi Service"],
    ["Best Alandi to Mumbai Cab Service", "Alandi to Mumbai Airport Cabs"],
    ["Cab Service in Alandi Pune", "Cab Service in Alandi Pune Contact Number"],
    ["Cab Service in Alandi", "Cab Service in Wadmukhwadi"],
    ["Cab Service in Charholi Budruk", "24 Hours Cab Service in Charholi"],
    ["Charholi to Mumbai Cab Service", "Moshi to Mumbai Cab Service"],
    ["Moshi to Mumbai Cab Fare", "Moshi to Mumbai Airport Cab Fare"],
    ["Moshi to Mumbai Round Trip Cab Fare", "Cab Service in Moshi"],
    ["Cheapest Cab Service in Moshi", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Alandi to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Alandi to Mumbai cab services with comfortable vehicles for business trips, airport transfers, and family travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from Alandi",
    WhyChoosedescription: "Enjoy doorstep pickup from Alandi, Chakan Road, Moshi, Bhosari, Dighi, and nearby Pune locations for a hassle-free journey."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our trained chauffeurs ensure safe driving, timely arrivals, and a smooth travel experience on the Pune-Mumbai route."
  },
  {
    WhyChooseheading: "Affordable Fare with No Hidden Charges",
    WhyChoosedescription: "Benefit from transparent pricing, competitive cab rates, and complete fare clarity before your trip begins."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Booking",
    WhyChoosedescription: "Book one-way cabs, round trips, or customized outstation travel packages that fit your schedule."
  },
  {
    WhyChooseheading: "Suitable for Airport & Corporate Travel",
    WhyChoosedescription: "Our cab service is ideal for Mumbai Airport transfers, official meetings, hotel transfers, and leisure trips."
  },
  {
    WhyChooseheading: "Instant Booking & Customer Support",
    WhyChoosedescription: "Receive quick fare quotations, fast booking confirmation, and dedicated assistance whenever you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Alandi to Mumbai Cabs Service?",
    answer: "Yes, Trustline Cab offers reliable Alandi to Mumbai cab services for one-way journeys, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Alandi to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with convenient doorstep pickup from Alandi and nearby areas."
  },
  {
    question: "Which vehicles are available for Alandi to Mumbai travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for every type of traveler."
  },
  {
    question: "Do you provide pickup from nearby Alandi locations?",
    answer: "Yes, pickup is available from Alandi, Moshi, Bhosari, Dighi, Chakan Road, and surrounding localities."
  },
  {
    question: "Can I book a cab from Alandi to Mumbai Airport?",
    answer: "Yes, we provide direct airport transfer services to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in your booking."
  },
  {
    question: "Is Alandi to Mumbai cab service available 24/7?",
    answer: "Yes, Trustline Travels operates throughout the day and night to meet your travel requirements."
  },
  {
    question: "Can I reserve my cab before the travel date?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and desired pickup timing."
  },
  {
    question: "Do you provide cabs for family and business travel?",
    answer: "Yes, our Alandi to Mumbai cab services are suitable for family vacations, corporate travel, airport transfers, and group journeys."
  },
  {
    question: "How can I book an Alandi to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, travel date, destination, and preferred vehicle details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Kale",
    feedback: "Trustline Travels arranged a comfortable cab from Alandi to Mumbai for my business trip. The driver was professional, the vehicle was clean, and the journey was completed on schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Shinde",
    feedback: "Our family booked a cab from Alandi to Mumbai, and the service was outstanding. The ride was smooth, the car was spacious, and the booking process was quick and hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Alandi to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/alandi-to-mumbai-cab.webp",
  "description": "Book Alandi to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, airport transfers, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6087"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/alandi-to-mumbai-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Alandi to Mumbai Cab Service | Airport Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Alandi to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Get affordable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="cab service in alandi pune, Cab service in alandi pune contact number, Alandi to Mumbai Cabs Service, alandi to mumbai Airport Cabs, cab service in wadmukhwadi, cab service in charholi budruk, 24 hours cab service in charholi, charholi to mumbai cab service, moshi to mumbai cab, alandi to mumbai taxi service, alandi to mumbai one way cab, alandi to mumbai airport taxi, alandi mumbai innova cab, alandi mumbai ertiga cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Alanditomumbaicabservice;